export const ERROR = "error";
export const WARNING = "warning";
export const WAITING = "waiting";
export const CONFIRM = "confirm";
export const QUESTION = "question";
export const SUCCESS = "success";
export const CLOSE_SUCCESS = "closeSuccess";

export const createErrorFeedback = (
  uiFeedbackDispatch,
  title,
  msg,
  action = () => {},
) => {
  uiFeedbackDispatch({
    type: ERROR,
    error: {
      title: title,
      msg: msg,
      action: action,
    },
  });
};

export const createWarningFeedback = (
  uiFeedbackDispatch,
  title,
  msg,
  action = () => {},
) => {
  uiFeedbackDispatch({
    type: WARNING,
    warning: {
      title: title,
      msg: msg,
      action: action,
    },
  });
};

export const createConfirmFeedback = (
  uiFeedbackDispatch,
  title,
  text,
  handleOk = () => {},
  handleClose = () => {},
) => {
  uiFeedbackDispatch({
    type: CONFIRM,
    confirm: {
      title: title,
      text: text,
      handleOk: handleOk,
      handleClose: handleClose,
    },
  });
};

export const createQuestionFeedback = (
  uiFeedbackDispatch,
  title,
  question,
  children,
  handleOk = () => {},
  handleClose = () => {},
) => {
  uiFeedbackDispatch({
    type: QUESTION,
    question: {
      title: title,
      question: question,
      children: children,
      handleOk: handleOk,
      handleClose: handleClose,
    },
  });
};

export const createSuccessFeedback = (uiFeedbackDispatch, msg) => {
  uiFeedbackDispatch({
    type: SUCCESS,
    success: msg,
  });
};

export const closeSuccessFeedback = (uiFeedbackDispatch, uuid) => {
  uiFeedbackDispatch({
    type: CLOSE_SUCCESS,
    uuid: uuid,
  });
};

export const createWaiting = (uiFeedbackDispatch) => {
  uiFeedbackDispatch({
    type: WAITING,
    waiting: true,
  });
};

export const closeWaiting = (uiFeedbackDispatch) => {
  uiFeedbackDispatch({
    type: WAITING,
    waiting: null,
  });
};
